'use client';

import { useFormStatus } from 'react-dom';
import LoadingDots from '@/components/loading-dots';
import { useTransition } from 'react';
import { redirectToCheckout } from './actions';
import { useRouter } from 'next/navigation';

export default function CheckoutButton() {
  const { pending } = useFormStatus();
  const [isPending, startTransition] = useTransition();
  const router = useRouter();

  const isLoading = pending || isPending;

  const handleCheckout = () => {
    startTransition(async () => {
      const result = await redirectToCheckout();

      // If there's an error, we'll get a string back
      if (typeof result === 'string') {
        console.error(result);
        // You could show an error toast here
      }

      // The redirect should happen automatically from the server action
      // This is just a fallback in case something goes wrong
      router.refresh();
    });
  };

  return (
    <button
      className="block w-full rounded-full bg-black p-3 text-center text-sm font-medium text-white opacity-90 hover:opacity-100 dark:bg-white dark:text-black"
      onClick={handleCheckout}
      disabled={isLoading}
      type="button"
    >
      {isLoading ? <LoadingDots className="bg-white dark:bg-black" /> : 'Proceed to Checkout'}
    </button>
  );
}
